/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';

import { DatePicker } from 'primeng/datepicker';

import { environment } from './environments/environment';

import { Logger } from './app/@core/services/logger/logger.service';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const LOGGER = new Logger('Main');

if (environment.favicon !== 'blue') {
    document.querySelectorAll<HTMLLinkElement>('link[rel*="icon"], link[rel="manifest"]')
        .forEach(link => link.href = link.href.replace('/favicons/blue/', `/favicons/${environment.favicon}/`));
}

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));

if (environment.production) {
    enableProdMode();
    Logger.enableProductionMode();
}

DatePicker.prototype.getDateFormat = () => 'dd/mm/yy';
